module.exports = __webpack_public_path__ + "img/6_123.77ce8e98.png";